import styled from 'styled-components/macro'

const TruncatedText = styled.span`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`

export default TruncatedText
